import { CaseLinks, caseLinksManufacturer } from '@odo/shared-ui';
import type { PatientListItemType } from '../../../providers/patient/PatientsListProvider';

interface LinksCellProps {
    patient: PatientListItemType;
}

// Treatment plan portal (manufacturer wordmark) and Dental Monitoring, side by side.
export function LinksCell({ patient }: LinksCellProps) {
    return (
        <CaseLinks
            manufacturer={caseLinksManufacturer(patient.manufacturer)}
            manufacturerLink={patient.manufacturerLink}
            dmLink={patient.dmLink}
            className="justify-center"
        />
    );
}
